<div class="row">
  <div class="col-md-12" [hidden]="HideUserForm" [formGroup]="createUserForm">
    <h3 *ngIf="IsCreate">Create New User</h3>
    <h3 *ngIf="!IsCreate">Edit User</h3>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <label for="userEmail" class="col-md-2 col-form-label">Email</label>
          <div class="col-md-4">
            <input type="email" email formControlName="userEmail" class="form-control" id="userEmail" maxlength="500" [ngClass]="{'invalid': createUserForm.controls['userEmail'].hasError('required') && (createUserForm.controls['userEmail'].dirty || createUserForm.controls['userEmail'].touched)}" />
            <span style="color:red;" *ngIf="createUserForm.controls['userEmail'].hasError('email') ">Invalid Email Address</span>
            <span style="color:red;" *ngIf="createUserForm.controls['userEmail'].hasError('required') && createUserForm.controls['userEmail'].touched ">Please enter an Email Address</span>
          </div>
        </div>
        <div class="form-group row">
          <label for="userPassword" class="col-md-2 col-form-label">Password</label>
          <div class="col-md-4">
            <input type="password" class="form-control" id="userPassword" maxlength="50" required formControlName="userPassword" [ngClass]="{'invalid': createUserForm.controls['userPassword'].hasError('required') && (createUserForm.controls['userPassword'].dirty || createUserForm.controls['userPassword'].touched)}" />
            <span style="color:red;" *ngIf="createUserForm.controls['userPassword'].hasError('required') && createUserForm.controls['userPassword'].touched ">Please enter a Password</span>
          </div>
        </div>
        <div class="form-group row" [hidden]="!IsCreate">
          <label for="userPasswordReenter" class="col-md-2 col-form-label">Re-Enter Password</label>
          <div class="col-md-4">
            <input type="password" class="form-control" id="userPasswordReEnter" maxlength="50" [(ngModel)]="ReEnterPassword" [ngModelOptions]="{standalone:true}" />
            
            <span style="color:red;" class="validationMessage" [hidden]="ReEnterPassword == createUserForm.controls['userPassword'].value || (ReEnterPassword != createUserForm.controls['userPassword'].value && ReEnterPassword.length == 0)"><br />Passwords must match</span>
          </div>
        </div>

        <div class="form-group row">
          <label for="userFirstName" class="col-md-2 col-form-label">First Name</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userFirstName" maxlength="500" formControlName="userFirstName" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userLastName" class="col-md-2 col-form-label">Last Name</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userLastName" maxlength="500" formControlName="userLastName" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userPhone" class="col-md-2 col-form-label">Primary Contact Number</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userPhone" formControlName="userPhone" maxlength="50" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userCompany" class="col-md-2 col-form-label">Company</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userCompany" formControlName="userCompany" maxlength="500" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userAddress1" class="col-md-2 col-form-label">Address #1</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userAddress1" formControlName="userAddress1" maxlength="500" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userAddress2" class="col-md-2 col-form-label">Address #2</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userAddress2" formControlName="userAddress2" maxlength="500" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userCity" class="col-md-2 col-form-label">City</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userCity" formControlName="userCity" maxlength="128" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userState" class="col-md-2 col-form-label">State</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userState" formControlName="userState" maxlength="128" />
          </div>
        </div>
        <div class="form-group row">
          <label for="userZipCode" class="col-md-2 col-form-label">Zip Code</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userZipCode" formControlName="userZipCode" maxlength="50"  />
          </div>
        </div>
        <div class="form-group row">
          <label for="userCountry" class="col-md-2 col-form-label">Country</label>
          <div class="col-md-4">
            <input type="text" class="form-control" id="userCountry" formControlName="userCountry" maxlength="50" />
          </div>
        </div>
        <!--<div class="form-group row">
    <label for="userDistributor" class="col-md-2 col-form-label">Distributor</label>
    <div class="col-md-4">
      <input type="text" class="form-control" id="userDistributor" [(ngModel)]="NewUser.Distributor" maxlength="500" required />
    </div>
  </div>-->

        <div class="form-group row">
          <label for="userDefaultUOM" class="col-md-2 col-form-label">Default UOM</label>
          <div class="col-md-4">
            <mat-button-toggle-group formControlName="userDefaultUOM">
              <mat-button-toggle color="primary" [value]="'ENGLISH'">ENGLISH</mat-button-toggle>
              <mat-button-toggle color="primary" [value]="'METRIC'">METRIC</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <ng-container *ngIf="IsTolomaticUser || LoggedInUser.Role == 'distributor-manager'">
          <div class="form-group row" *ngIf="LoggedInUser.IsTolomaticUser">
            <label for="userDistributor" class="col-md-2 col-form-label">Distributor</label>
            <div class="col-md-4">
              <mat-select id="userDistributor" [(value)]="NewUser.DistributorId">
                <mat-option *ngFor="let dist of Distributors" [value]="dist.CompanyId">
                  {{dist.Company}}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="form-group row">
            <label for="userRole" class="col-md-2 col-form-label">Role</label>
            <div class="col-md-4">
              <mat-select id="userRole" [(value)]="NewUser.Role">
                <mat-option *ngIf="LoggedInUser.IsTolomaticUser" value="administrator">
                  Administrator
                </mat-option>
                <mat-option [hidden]="NewUser.DistributorId == null" value="distributor-manager">
                  Distributor Manager
                </mat-option>
                <mat-option [hidden]="NewUser.DistributorId == null" value="distributor">
                  Distributor
                </mat-option>
                <!--<mat-option value="user">
      User
    </mat-option>-->
                <mat-option *ngIf="!IsCreate" value="inactive">
                  Inactive
                </mat-option>
              </mat-select>
            </div>
          </div>
        </ng-container>
        <div [hidden]="true" class="form-group row">
          <label for="userFileType" class="col-md-2 col-form-label">Solid Type</label>
          <mat-select id="userFileType" class="col-md-4" [(value)]="NewUser.SolidType">
            <mat-option value="sldasm">
              Solid Works file
            </mat-option>
            <mat-option value="sat">
              Acis Version 21
            </mat-option>
            <mat-option value="step">
              Step Solid
            </mat-option>
            <mat-option value="igs">
              IGES version 5.3
            </mat-option>
            <mat-option value="x_t">
              parasolid version 16
            </mat-option>
            <mat-option value="slddrw">
              2d Solid works drawing format
            </mat-option>
            <mat-option value="dwg">
              2d dwg drawing format
            </mat-option>
            <mat-option value="dxf">
              2d dxf drawing format
            </mat-option>
            <mat-option value="easm">
              eDrawing assembly format
            </mat-option>
            <mat-option value="edrw">
              eDrawing drawing format
            </mat-option>
          </mat-select>
        </div>
        <div [hidden]="true" class="form-group row">
          <label for=" userDeliveryType" class="col-md-2 col-form-label">Delivery Type</label>
          <mat-select id="userDeliveryType" class="col-md-4" [(value)]="NewUser.DeliveryType">
            <mat-option value="http">
              http download (link provided through E-mail)
            </mat-option>
            <mat-option value="Email">
              send as an attachment to E-mail
            </mat-option>
          </mat-select>
        </div>

        <div *ngIf="ValidationMessage.length > 0" class="form-group row">
          <div class="col-md-6">
            <span style="color:red;">{{ValidationMessage}}</span>
          </div>
        </div>
        <div class="form-group row-no-margin text-center" style="width:50%;">
          <div style="width:50%;">
            <button *ngIf="IsCreate" (click)="CreateUser()" class="blue">Create</button>
            <button *ngIf="!IsCreate" (click)="UpdateUser()" class="blue">Update</button>
          </div>
          <div style="width:50%;">
            <button (click)="CancelCreateUser()" class="primary-white-button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12" [hidden]="!HideUserForm">
    <div class="form-group row">
      <label class="col-md-6 col-form-label" style="margin-right:auto;margin-left:auto;">Email verification sent.  Please check your email and click on the link provided to verify your account.</label>
    </div>
    <div class="form-group row">
      <button (click)="ReturnToHomePage()" class="primary-blue-button" style="margin-right:auto;margin-left:auto;">Return to Login</button>
    </div>
  </div>
</div>
<div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:90%;position:absolute;z-index:10000;display:block;top: 80px;;left:0; background-color:#AAAAAA;opacity:0.4;">
  <div style="position:fixed;top:45%;left:45%;">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
</div>
